module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (171).c1730d84.jpg";